
<div
  :class="
    classes(
      n(),
      {
        [n('--disabled')]: mergedDisabled,
        [n('--focused')]: isFocused,
        [n('--in-form-item')]: inFormItem,
      }
    )
  "
>
  <div :class="n('wrapper')">
    <textarea
      ref="textareaRef"
      :class="n('native')"
      :value="innerValue"
      :placeholder="placeholder"
      :placeholder-class="n('placeholder')"
      :disabled="mergedDisabled"
      v-bind="readonly ? { readonly: true } : {}"
      :maxlength="maxlength"
      :rows="rows"
      :name="name"
      :autofocus="autofocus"
      :adjust-position="adjustPosition"
      :style="textareaStyle"
      @input="handleInput"
      @focus="handleFocus"
      @blur="handleBlur"
      @change="handleChange"
      @keydown="handleKeydown"
      @keyup="handleKeyup"
    />
    <!-- 字数统计（在横线上方右下角） -->
    <div
      v-if="showWordLimit && maxlength"
      :class="n('word-limit')"
    >
      {{ String(innerValue || '').length }}/{{ maxlength }}
    </div>
  </div>
</div>
